import { stringify } from 'querystring';
import React from 'react';
import styled from 'styled-components';
import { BrowseCategorySlug } from '@engage/browse-categories/models';
import { useReduxAction, useReduxState } from '@engage/redux/hooks';
import { spaces } from '@engage/styles/spaces';
import { Button2Small } from '@members/buttons/buttons';
import { BookmarksCopy } from '@members/copy/copy.generated';
import { Bookmarks } from '@members/copy/models.generated/Bookmarks';
import { useFeatureToggle } from '@members/feature-toggles/featureToggles';
import { Feature } from '@members/feature-toggles/toggles';
import { useMembersRouter } from '@members/localization/useMembersRouter';
import { toLibraryCategoryRoute } from '@members/routes/library';
import { getBookmarkErrorType, hideBookmarkError } from '../redux';
import { StandardToast } from '../StandardToast';

const ANALYTICS_SOURCE = 'bookmark_limit_banner';
const bookmarkFilterMap = { ['is_favorite_ride']: JSON.stringify(['true']) };

export const BookmarkLimitToast: React.FC = () => {
  const bookmarkLimitEnabled = useFeatureToggle(Feature.Bookmark_limit);
  const bookmarkErrorType = useReduxState(getBookmarkErrorType);
  const dismissToast = useReduxAction(hideBookmarkError);
  const router = useMembersRouter();
  const isLimitError = bookmarkErrorType === 'limit';

  const handleManageCta = () => {
    dismissToast();
    router.push(
      {
        pathname: toLibraryCategoryRoute(BrowseCategorySlug.All),
        query: { ...bookmarkFilterMap, source: ANALYTICS_SOURCE },
      },
      toLibraryCategoryRoute(BrowseCategorySlug.All) + `?${stringify(bookmarkFilterMap)}`,
    );
  };

  if (!bookmarkLimitEnabled || !bookmarkErrorType) {
    return null;
  }

  return (
    <BookmarkToast autoDismiss onClose={dismissToast}>
      <BookmarksCopy
        id={isLimitError ? Bookmarks.LimitReached : Bookmarks.GenericError}
      />
      {isLimitError && (
        <ManageCta onClick={handleManageCta}>
          <BookmarksCopy id={Bookmarks.Manage} />
        </ManageCta>
      )}
    </BookmarkToast>
  );
};

const BookmarkToast = styled(StandardToast)`
  border-radius: ${spaces.small}px;
  .toast__message-and-icon {
    padding: ${spaces.small}px;
  }
`;

const ManageCta = styled(Button2Small)`
  margin-left: ${spaces.small}px;
  white-space: nowrap;
`;
